import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PlanCard from '@/components/smartpos/PlanCard';
import PlanComparison from '@/components/smartpos/PlanComparison';
import { pricingPlans, planStyles } from '@/lib/pricingPlans';
import { useLanguage } from '@/lib/LanguageContext';

function useReveal(ref) {
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(([e]) => {if (e.isIntersecting) setRevealed(true);}, { threshold: 0.1 });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref]);
  return revealed;
}

export default function PricingSection() {
  const ref = useRef(null);
  const revealed = useReveal(ref);
  const navigate = useNavigate();
  const { lang, t } = useLanguage();

  const content = pricingPlans[lang] || pricingPlans.ES;
  const plans = content.plans.map((plan, i) => ({ ...plan, ...planStyles[i] }));

  const upgrades = [
  {
    name: 'CashDro',
    tag: t('pricing.tag.cajon'),
    price: t('pricing.starter.price').replace(/\d+/, '99'),
    period: t('pricing.starter.period'),
    image: 'https://media.base44.com/images/public/6a877e598e2aae01ac439787/b08291c3b_cashdro.webp',
    href: '/cashdro',
    accent: '#0ff0b3'
  },
  {
    name: 'HioPay',
    tag: t('pricing.tag.pagos'),
    price: t('pricing.starter.price').replace(/\d+/, '39'),
    period: t('pricing.starter.period'),
    image: 'https://media.base44.com/images/public/6a877e598e2aae01ac439787/18cae7592_image.png',
    href: '/medios-pago',
    accent: '#0095fc'
  },
  {
    name: t('pricing.upgrade.datfono'),
    tag: t('pricing.tag.terminal'),
    price: '0€',
    period: t('pricing.starter.period'),
    image: 'https://media.base44.com/images/public/6a877e598e2aae01ac439787/707b46114_segunda-pantalla-tpv-tactil-hiopos-sun9-android-156.jpg',
    href: '/medios-pago',
    accent: '#7800f7'
  },
  {
    name: 'Quiosco TQ1',
    tag: t('pricing.tag.autoservicio'),
    price: t('pricing.starter.price').replace(/\d+/, '89'),
    period: t('pricing.starter.period'),
    image: 'https://media.base44.com/images/public/6a877e598e2aae01ac439787/0fcf55769_TQ1-600x849-1.webp',
    href: '/quioscos-autoservicio',
    accent: '#7800f7'
  },
  {
    name: t('pricing.upgrade.pack'),
    tag: t('pricing.tag.hardware'),
    price: t('pricing.starter.price').replace(/\d+/, '29'),
    period: t('pricing.starter.period'),
    image: 'https://media.base44.com/images/public/6a877e598e2aae01ac439787/ef7213a21_TPV-HIOPOS-SUN9.jpg',
    href: '/hardware-tpv',
    accent: '#0095fc'
  }];


  const goToDemo = () => navigate('/demo');

  return (
    <section id="precios" ref={ref} className="pt-32 pb-24 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className={`text-center mb-16 transition-all duration-700 ${revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-black tracking-widest uppercase text-brand-blue mb-4 px-3 py-1 bg-blue-50 rounded-full">{t('pricing.eyebrow')}</span>
          <h1 className="font-heading font-light text-4xl lg:text-5xl text-gray-900 leading-tight mb-4 tracking-tight">
            {t('pricing.title1')} <span className="text-brand-blue">{t('pricing.titleHighlight')}</span>{t('pricing.titleEnd')}
          </h1>
          <p className="text-gray-500 text-lg font-light max-w-2xl mx-auto">
            {t('pricing.desc')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 items-stretch">
          {plans.map((plan, i) =>
          <PlanCard
            key={plan.name}
            plan={plan}
            revealed={revealed}
            delay={`${200 + i * 120}ms`}
            onSelect={goToDemo} />

          )}
        </div>

        <PlanComparison revealed={revealed} />

        <div className={`mt-10 text-center transition-all duration-700 delay-500 ${revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-gray-400 text-sm font-light">
            {t('pricing.footerNote')}
          </p>
        </div>

        {/* Upgrades */}
        






































        
      </div>
    </section>);

}